import { useEffect, useMemo, useState } from "react";
import { WaardelijstenApi } from "../api/waardelijsten";
import { IdentifierWithChildren } from "../factories/waardelijst";
import { Identifier } from "../models";

const waardelijstFactory = new WaardelijstenApi();

interface OrganisatiesState {
  ministeries: IdentifierWithChildren[];
  overige: IdentifierWithChildren[];
  zelfstandige: IdentifierWithChildren[];
  samenwerking: IdentifierWithChildren[];
  gemeenten: IdentifierWithChildren[];
  provincies: IdentifierWithChildren[];
  waterschappen: IdentifierWithChildren[];
}

export const useOrganisaties = () => {
  const [organisaties, setOrganisaties] = useState<OrganisatiesState>({
    ministeries: [],
    overige: [],
    zelfstandige: [],
    samenwerking: [],
    gemeenten: [],
    provincies: [],
    waterschappen: [],
  });

  const publicerendePartijen: IdentifierWithChildren[] = useMemo(() => {
    const list = Object.values(organisaties).flat();
    return list.sort((a: Identifier, b: Identifier) => a.label!.localeCompare(b.label!));
  }, [organisaties]);

  useEffect(() => {
    const fetchers: [keyof OrganisatiesState, () => Promise<IdentifierWithChildren[]>][] = [
      ["ministeries", waardelijstFactory.getMinisterie],
      ["overige", waardelijstFactory.getOverigeOrganisaties],
      ["zelfstandige", waardelijstFactory.getZelfstandigeBestuurorganen],
      ["samenwerking", waardelijstFactory.getSamenwerkingsOrganisaties],
      ["gemeenten", waardelijstFactory.getGemeentenOrganisaties],
      ["provincies", waardelijstFactory.getProvinciesOrganisaties],
      ["waterschappen", waardelijstFactory.getWaterschappenOrganisaties],
    ];

    for (const [key, fn] of fetchers) {
      fn().then((data) => setOrganisaties((prev) => ({ ...prev, [key]: data })));
    }
  }, []);

  return {
    organisaties,
    publicerendePartijen,
  };
};

export function filterActievePublishers(publicerendePartijen: Identifier[], orgMemLijst: Identifier[]): Identifier[] {
  if (!Array.isArray(publicerendePartijen) || !Array.isArray(orgMemLijst)) {
    return [];
  }
  const resultaat = publicerendePartijen.filter((p) => orgMemLijst.some((o) => p.id === o.id && p.label === o.label));
  resultaat.sort((a, b) => a.label!.localeCompare(b.label!));
  return resultaat;
}

export function getOrganisatiesForpubicatiebestemming(
  publicatiebestemming: string[] | undefined,
  organisaties: any,
  publicerendePartijen: any
) {
  return publicatiebestemming?.[0] === "rijksoverheid.nl" ? organisaties.ministeries : publicerendePartijen;
}
